'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var PropTypes = React.PropTypes;

var DropdownRegistry = require('./DropdownRegistry');

var _require = require('exenv');

var canUseDOM = _require.canUseDOM;

var Dropdown = function (_React$Component) {
  _inherits(Dropdown, _React$Component);

  Dropdown.prototype.getChildContext = function getChildContext() {
    return {
      dropdownRegistry: this.dropdownRegistry
    };
  };

  function Dropdown(props, context) {
    _classCallCheck(this, Dropdown);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.handleDocumentKeydown = function (event) {
      var keyCode = event.keyCode;

      if (keyCode === 40) {
        // down
        event.preventDefault();
        _this.dropdownRegistry.focusNext();
      } else if (keyCode === 38) {
        // up
        event.preventDefault();
        _this.dropdownRegistry.focusPrev();
      } else if (keyCode === 27) {
        // esc
        _this.props.onClose();
      }
    };

    _this.handleDocumentClick = function (event) {
      _this.props.onClose();
    };

    _this.dropdownRegistry = new DropdownRegistry();
    return _this;
  }

  Dropdown.prototype.componentDidMount = function componentDidMount() {
    if (canUseDOM) {
      global.document.addEventListener('keydown', this.handleDocumentKeydown);
      global.document.addEventListener('click', this.handleDocumentClick);
    }
  };

  Dropdown.prototype.componentWillUnmount = function componentWillUnmount() {
    if (canUseDOM) {
      global.document.removeEventListener('keydown', this.handleDocumentKeydown);
      global.document.removeEventListener('click', this.handleDocumentClick);
    }
  };

  Dropdown.prototype.render = function render() {
    return React.createElement(
      'ul',
      { role: 'menu', className: 'cf-dropdown cf-dropdown--' + this.props.align },
      this.props.children
    );
  };

  return Dropdown;
}(React.Component);

Dropdown.propTypes = {
  onClose: PropTypes.func.isRequired,
  align: PropTypes.oneOf(['left', 'right'])
};
Dropdown.defaultProps = {
  align: 'left'
};
Dropdown.childContextTypes = {
  dropdownRegistry: PropTypes.instanceOf(DropdownRegistry).isRequired
};


module.exports = Dropdown;